import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { Form } from '@kuzmycz/react-form-ula';
import { Button, Modal } from '../../../../Components/uielements';
import BioPlusTextField from '../../../../Components/form-fields/BioPlusTextField';
import {
  ModalButtonWrapper,
  ModalGap,
  ModalWrapper,
  OutlineButton,
} from '../../../../services/settings/appStyle/global.style';
import * as GeofenceService from '../../../../services/bioplus-services/geofence';
import { IntlMessages } from '../../../../helper/langHelper';

const EditGeofenceModal = ({ onClose, data, isPartner = false }) => {
  const queryClient = useQueryClient();

  const mutation = useMutation((geofence) => GeofenceService.updateGeofence(geofence), {
    onSuccess: async () => {
      await queryClient.invalidateQueries('partnerGeofences');
      onClose();
    },
    onError: (error) => {
      alert(`Error: ${error?.response?.data?.message}`);
      onClose();
    },
  });

  const handleSubmit = (values) => {
    mutation.mutate(values);
  };

  const validator = (values) => {
    return undefined;
  };

  return (
    <>
      <Modal
        isOpen={true}
        onClose={onClose}
        title={<IntlMessages id="modal.edit.geofence.title" />}
      >
        <Form initialValues={data} validator={validator} onSubmit={handleSubmit}>
          <ModalWrapper>
            <ModalGap>
              {isPartner ? (
                <BioPlusTextField
                  name="companyId.name"
                  label={<IntlMessages id="table.col.account.owner" />}
                  fullWidth
                />
              ) : (
                <BioPlusTextField
                  name="companyName"
                  label={<IntlMessages id="table.col.company" />}
                  fullWidth
                />
              )}
              {isPartner ? (
                <BioPlusTextField
                  name="premiseId.propertyName"
                  label={<IntlMessages id="table.col.premise.name" />}
                  fullWidth
                />
              ) : (
                <BioPlusTextField
                  name="premiseName"
                  label={<IntlMessages id="table.col.premise.name" />}
                  fullWidth
                />
              )}

              <BioPlusTextField
                name="name"
                label={<IntlMessages id="table.col.geofence" />}
                fullWidth
              />
              {!isPartner && (
                <>
                  <BioPlusTextField
                    name="registeredOccupants"
                    label={<IntlMessages id="table.col.occupied.reg" />}
                    fullWidth
                  />
                  <BioPlusTextField
                    name="unregisteredOccupants"
                    label={<IntlMessages id="table.col.occupied.unReg" />}
                    fullWidth
                  />
                </>
              )}
              <BioPlusTextField
                name="createdBy"
                label={<IntlMessages id="table.col.creator" />}
                fullWidth
              />
            </ModalGap>
            <ModalButtonWrapper>
              <OutlineButton onClick={onClose}>
                <IntlMessages id="modal.button.cancel" />
              </OutlineButton>
              <Button varient="normal" type="submit">
                <IntlMessages id="modal.button.submit" />
              </Button>
            </ModalButtonWrapper>
          </ModalWrapper>
        </Form>
      </Modal>
    </>
  );
};

export default EditGeofenceModal;
